import { Box, Button, Grid, OutlinedInput } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { backend } from "../../../api";
import { addDate } from "../../../utils";
import { CopyToClipboard } from "react-copy-to-clipboard";

const useStyles = makeStyles((theme) => ({
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
}));
const CreateAdCard = ({ book }) => {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const [adCard, setAdCard] = useState(null);
  const handleCreateAdCard = async () => {
    try {
      const { data } = await backend.post("/adcard", {
        member_id: currentUser._id,
        book: book,
        eksplode_code: currentUser.eksplode_code,
        shareable_link: `${
          process.env.NODE_ENV === "production"
            ? process.env.REACT_APP_FRONTEND
            : process.env.REACT_APP_FRONTEND_DEV
        }/book/${book._id}?promoted_by=${currentUser._id}`,
        date_created: new Date(),
        expiry_date: addDate(),
      });
      toast.success("Ad card created successfully");
      setAdCard(data.data[0]);
    } catch (err) {
      toast.error(err.response ? err.response.data.message : err.response);
      setAdCard(err.response.data.data[0]);
    }
  };

  return (
    <div>
      {!adCard ? (
        <Box>
          <Button
            className={classes.addBtn}
            onClick={() => handleCreateAdCard()}
            fullWidth
          >
            Create AdCard
          </Button>
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={9} sm={7} md={8} lg={8}>
            <OutlinedInput
              fullWidth
              value={adCard?.shareable_link}
              className={classes.input}
            />
          </Grid>
          <Grid item xs={5} sm={5} md={4} lg={4}>
            <CopyToClipboard
              text={adCard?.shareable_link}
              onCopy={() => toast.success("Copied to Clipboard")}
            >
              <Button className={classes.addBtn} fullWidth>
                Copy Link
              </Button>
            </CopyToClipboard>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default CreateAdCard;
